/**
 * Module-level brand for non-React helpers (checkout PDF-ish UI bits).
 * Set once after storefront config resolves; defaults to FE-05a config.
 */
import { brand as fallbackBrand } from "./config";

let _brand = fallbackBrand;

export function setRuntimeBrand(next) {
  _brand = next || fallbackBrand;
}

export function getRuntimeBrand() {
  return _brand;
}

export function getRuntimeBRAND() {
  return _brand.colors;
}
